module.exports = __webpack_public_path__ + "static/media/main-girl.76b36dd8.png";